import './QuestionText.css';

type QuestionTextProps = {
  text: string;
};

/** Figma question_text (161:23925) — dynamic prompt from quiz bank. */
export function QuestionText({ text }: QuestionTextProps) {
  return (
    <p
      className="quiz-question-text quiz-outlined-text quiz-content-enter"
      role="heading"
      aria-level={2}
    >
      {text}
    </p>
  );
}
